import { Injectable } from '@angular/core';
import { HttpClient, HttpStatusCode } from '@angular/common/http';
import { BodyPrefill, NoteToResponseTeam, SurveyAnswer, SurveyIntervention, SurveySession, SurveySessionAnswer } from './survey.model';
import { lastValueFrom } from 'rxjs';
import { SurveyFeedbackRecipients } from './survey-feedback.model';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {
  constructor(private http: HttpClient) {}

  startAnswer(isOnDemand: boolean): Promise<number> {
    return lastValueFrom(this.http
      .post<number>(`/api/Answer/StartAnswer?isOnDemand=${isOnDemand}`, {}));
  }

  saveAnswer(answer: SurveyAnswer): Promise<SurveyIntervention> {
    return lastValueFrom(this.http
      .post<SurveyIntervention>(`/api/Answer/SaveAnswer`, answer));
  }

  getBodyPrefillFromPreviousAnswer(): Promise<BodyPrefill | undefined> {
    return lastValueFrom(this.http
      .get<BodyPrefill>(`/api/Survey/GetBodyPrefillFromPreviousAnswer`));
  }

  saveSurveySessionAnswer(id: number, model: SurveySessionAnswer): Promise<SurveyIntervention> {
    return lastValueFrom(this.http
      .put<SurveyIntervention>(`/api/Survey/SaveSurvey?id=${id}`, model));
  }

  saveEmptyFeedback(id: number): Promise<HttpStatusCode> {
    return lastValueFrom(this.http
      .put<HttpStatusCode>(`/api/Survey/SaveEmptyFeedback?id=${id}`, {}));
  }

  startSurveySession(surveyId: number, isOnDemand = false): Promise<SurveySession> {
    return lastValueFrom(this.http
      .post<SurveySession>(`/api/Survey/StartSurvey?surveyId=${surveyId}&isOnDemand=${isOnDemand}`, {}));
  }

  getRecipientList(): Promise<SurveyFeedbackRecipients> {
    return lastValueFrom(this.http
      .get<SurveyFeedbackRecipients>(`/api/Survey/GetRecipientList`));
  }

  contactMe(): Promise<HttpStatusCode> {
    return lastValueFrom(this.http.post<HttpStatusCode>('/api/Answer/ContactMe', {}));
  }

  contactMeBody(): Promise<HttpStatusCode> {
    return lastValueFrom(this.http.post<HttpStatusCode>('/api/Survey/ContactMeBody', {}));
  }

  saveNote(note: string): Promise<NoteToResponseTeam> {
    return lastValueFrom(this.http.post<NoteToResponseTeam>(`/api/Answer/SaveNote?note=${note}`, {}));
  }

  updateNote(noteId: number, note: string): Promise<NoteToResponseTeam> {
    return lastValueFrom(this.http.patch<NoteToResponseTeam>('/api/Answer/UpdateNote', { noteId, note }));
  }
}
